export default {
  // ===== User management =====
  'global.users.cardTitle': 'User Management',
  'global.users.refreshButton': 'Refresh',
  'global.users.searchPlaceholder': 'Search by email, nickname or phone',
  'global.users.statusFilter': 'Status',
  'global.users.roleFilter': 'Role',
  'global.users.searchButton': 'Search',
  'global.users.tableTotal': '{total} users in total',

  'global.users.column.user': 'User',
  'global.users.column.email': 'Email',
  'global.users.column.phone': 'Phone',
  'global.users.column.realName': 'Real Name',
  'global.users.column.deptName': 'Department',
  'global.users.column.positionName': 'Position',
  'global.users.column.roles': 'Roles',
  'global.users.column.status': 'Status',
  'global.users.column.lastLogin': 'Last Active',
  'global.users.column.actions': 'Actions',
  'global.users.column.tenantName': 'Tenant',

  'global.users.action.detail': 'Detail',
  'global.users.action.role': 'Role',
  'global.users.action.unban': 'Unban',
  'global.users.action.ban': 'Ban',

  'global.users.banConfirm': 'Are you sure to ban this user?',
  'global.users.unbanConfirm': 'Are you sure to unban this user?',

  'global.users.status.active': 'Active',
  'global.users.status.disabled': 'Disabled',
  'global.users.status.locked': 'Locked',
  'global.users.status.banned': 'Banned',

  'global.users.loadFailed': 'Failed to load',
  'global.users.loadListFailed': 'Failed to load user list',
  'global.users.getDetailFailed': 'Failed to load detail',
  'global.users.getUserDetailFailed': 'Failed to load user detail',
  'global.users.roleUpdateSuccess': 'Role updated',
  'global.users.updateFailed': 'Failed to update',
  'global.users.roleUpdateFailed': 'Failed to update role',
  'global.users.userBanned': 'User banned',
  'global.users.userUnbanned': 'User unbanned',
  'global.users.operationFailed': 'Operation failed',
  'global.users.statusUpdateFailed': 'Failed to update status',

  'global.users.stats.total': 'Total Users',
  'global.users.stats.active': 'Active',
  'global.users.stats.verified': 'Verified',
  'global.users.stats.banned': 'Banned',
  'global.users.stats.todayNew': 'New Today',
  'global.users.stats.todayActive': 'Active Today',

  'global.users.detailModal.title': 'User Detail',
  'global.users.detail.id': 'ID',
  'global.users.detail.nickname': 'Nickname',
  'global.users.detail.email': 'Email',
  'global.users.detail.emailVerified': 'Verified',
  'global.users.detail.emailNotVerified': 'Unverified',
  'global.users.detail.phone': 'Phone',
  'global.users.detail.status': 'Status',
  'global.users.detail.roles': 'Roles',
  'global.users.detail.loginMethods': 'Login Methods',
  'global.users.detail.referralCode': 'Referral Code',
  'global.users.detail.lastLogin': 'Last Active',
  'global.users.detail.createdAt': 'Registered At',
  'global.users.detail.google': 'Google',
  'global.users.detail.oaProfiles': 'OA Profiles',
  'global.users.detail.tenantCount': '{count} tenants',

  'global.users.rolesModal.title': 'Edit Roles - {name}',
  'global.users.rolesModal.operationLabel': 'Operation',
  'global.users.rolesModal.operationRequired': 'Please choose an operation',
  'global.users.rolesModal.opReplace': 'Replace (override existing)',
  'global.users.rolesModal.opAssign': 'Assign',
  'global.users.rolesModal.opRemove': 'Remove',
  'global.users.rolesModal.rolesLabel': 'Roles',
  'global.users.rolesModal.rolesRequired': 'Please select at least one role',
  'global.users.rolesModal.rolesPlaceholder': 'Select roles',
};
